const CampaignStatus = ({ donatedAmount, donationGoal, donors }) => {
    return (
        <div className="mt-2 mb-4">
            <div className="mb-2">
                <p className="font-bold text-xl">{ donatedAmount }</p>
                <p className="text-base">Donated of { donationGoal } goal</p>
            </div>
            <div>
                <p className="font-bold text-xl">{ donors }</p>
                <p className="text-base">Donors</p>
            </div>
        </div>
    )
};

export default CampaignStatus;